import Api from '../index';
import { endPoints, requestType } from '../../constants/variables';

export const getAllComplaints = (id) => {
  return Api(`${endPoints.getComplaints}`, null, requestType.GET);
};

export const updateCategoryStatus = (params) => {
  return Api(`${endPoints.updateRequestedCategory}`, params, requestType.POST);
};
